<div class="d-flex justify-content-center mt-5" *ngIf="loading">
    <div class="row me-6 me-3">{{'Redirecting' | translate}}... </div>
    <lib-loader></lib-loader>
</div>